import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: 25,
  },
  language: {
    minWidth: 'auto',
    width: 25,
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '0.7rem!important',
    borderRadius: '2px!important',

    '&.MuiButton-containedPrimary': {
      '&:hover,&:focus': {
        backgroundColor: `${theme.palette.primary.main}!important`,
      },
    },
  },
  selected: {
    color: 'white',
  },
  divider: {
    marginLeft: 5,
    marginRight: 5,
  },
}));
